import React from "react";

import Slide from "react-reveal/Slide";
import theme, { roundness } from "../../../utils/styles";

const Card = (props) => {
  const { index, show, data, hover, hoverIndex, isBreakpoint } = props;
  const { title, img, text, color } = data;

  const stylesProps = {
    isBreakpoint,
    hover,
    index,
    hoverIndex,
  };

  const executeScroll = (id) => {
    if (document.location.pathname === "/") {
      if (id[0] === "/") {
        window.location.href = id;
      } else {
        const traget = document.getElementById(id);
        window.history.pushState({}, "", "/" + id);
        traget.scrollIntoView();
      }
    } else {
      if (id[0] !== "/") {
        window.location.href = "/" + id;
      }
    }
  };

  return (
    <Slide left when={show} duration={200 * (1 + index)}>
      <div style={styles(stylesProps).bg}>
        <div style={styles(stylesProps).root(color)}>
          <div style={styles(stylesProps).content}>
            <img src={img} alt={title} style={styles(stylesProps).image}></img>
            <div style={styles(stylesProps).title}>{title}</div>
            <div style={styles(stylesProps).text}>{text}</div>
            <div
              style={styles(stylesProps).link}
              onClick={(e) => executeScroll("#projects")}
            >
              Learn More
            </div>
          </div>
        </div>
      </div>
    </Slide>
  );
};

export default Card;

const styles = (stylesProps) => {
  const { hover, hoverIndex, index } = stylesProps;

  const widthInit = 280;
  const heightInit = 370;
  const transition = "ease-in-out 0.4s";
  const increment = 8;
  const height =
    hover && hoverIndex === index ? heightInit + increment : heightInit;
  const width =
    hover && hoverIndex === index ? widthInit + increment : widthInit;

  return {
    bg: {
      background: theme.colors.gray1,
      borderRadius: roundness.card,
      transition,
      opacity: hover && hoverIndex !== index ? 1 : 0,
      height,
      width,
    },
    root: (color) => ({
      background: color,
      borderRadius: roundness.card,
      transition,
      opacity: hover && hoverIndex !== index ? 0.3 : 1,
      height,
      width,
    }),
    content: {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "flex-start",
      flexDirection: "column",
      rowGap: 20,
      padding: 20,
    },
    image: {
      height: 80,
    },
    title: {
      fontWeight: "bold",
      fontSize: 25,
      color: "white",
      height: 50,
      width: width - 40,
    },
    text: {
      fontSize: "14px",
      color: "white",
      lineHeight: 1.5,
      width: width - 40,
    },
    link: {
      display: hover && hoverIndex === index ? "block" : "none",
      fontSize: "16px",
      color: "white",
      borderStyle: "none none solid none",
      borderWidth: 2,
      transition,
      cursor: "pointer",
    },
  };
};
